export const DEFAULT_INBOX_FILTER = 'ACTIVE';
